import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {MultipleInvitationRequest} from "../interface/multipleInvitationRequest";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  sendMultipleInvitations(invitationRequest: MultipleInvitationRequest): Observable<string> {
    return this.http.post<string>(`${this.apiUrl}/invitations/send-multiple`, invitationRequest, {responseType: 'text' as 'json'});
  }

  checkUsernameExists(cardId: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/user/card/exists/${encodeURIComponent(cardId)}`);
  }
}
